import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import lo from './locales/lo.json';

// Get saved language from localStorage or default to 'en'
// Use a try-catch to handle cases where localStorage might not be available
let savedLanguage = 'en';
try {
  savedLanguage = localStorage.getItem('language') || 'en';
} catch (e) {
  console.warn('localStorage not available, using default language');
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      lo: {
        translation: lo
      }
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    react: {
      useSuspense: false  // Disable to prevent loading deadlock
    },
    interpolation: {
      escapeValue: false
    }
  });

// Keep <html lang> in sync so language-specific fonts (Noto Sans Lao) apply.
const applyHtmlLang = (lng) => {
  try {
    if (typeof document !== 'undefined' && document.documentElement) {
      document.documentElement.setAttribute('lang', lng || 'en');
    }
  } catch (e) {
    /* no-op */
  }
};

applyHtmlLang(i18n.language);
i18n.on('languageChanged', applyHtmlLang);

export default i18n;
